import React from "react";
import { Button, Typography } from "@mui/material";
import Table from "components/shared/Table";
import { TableColumn } from "store/types/Table";
import Reports, { ReportType } from "store/types/Reports";

interface ReportsTableProps {
  reports: Array<Reports>;
  className?: string;
  onClick: (
    e: React.MouseEvent<HTMLElement>,
    title: string,
    subTitle: string,
    contentTypeId: number,
    reportType: ReportType,
    showDates: boolean,
    selectMultiple: boolean,
    showHelperText: boolean,
    showFailuresFlag: boolean,
    formats: string[]
  ) => void;
}

const ReportsTable: React.FunctionComponent<ReportsTableProps> = ({ reports, className = "", onClick }) => {
  const tableColumns: Array<TableColumn<Reports>> = [
    {
      dataIndex: "title",
      label: <Typography fontWeight="bold">Report Title</Typography>,
      render: (_, record) => <Typography>{record.title}</Typography>,
    },
    {
      dataIndex: "description",
      label: <Typography fontWeight="bold">Description</Typography>,
      render: (_, record) => <Typography>{record.description}</Typography>,
    },
    {
      dataIndex: "contentTypeId",
      label: <Typography fontWeight="bold"></Typography>,
      render: (_, record) => (
        <Button
          variant="text"
          color={"secondary"}
          onClick={(e) =>
            onClick(
              e,
              record.title,
              record.subTitle,
              record.contentTypeId,
              record.reportType,
              record.showDates,
              record.selectMultiple,
              record.showHelperText,
              record.showFailuresFlag,
              record.formats
            )
          }
        >
          <Typography fontWeight="bold" color={"secondary"}>
            {record.generationLabel}
          </Typography>
        </Button>
      ),
      align: "right",
    },
  ];

  return <Table list={reports} columns={tableColumns} noResultsText="No reports found" className={className} />;
};

export default ReportsTable;
